import GetHydrantByIdRequestModelBase from '../_generated/modelBases/get-hydrant-by-id-request-model-base';

export default class GetHydrantByIdRequestModel extends GetHydrantByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
